
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { usePermissions } from "@/context/PermissionsContext";
import { Resource } from "@/hooks/rollenbeheer/useRolePermissions";
import { UserRole } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { 
  Home, 
  Database, 
  Bell, 
  BarChart3, 
  Users,
  ShieldCheck,
  MessageSquare,
  LayoutDashboard,
  Package,
  UserPlus,
  Workflow,
  BookOpen,
  AlertTriangle,
  KeyRound,
  PackagePlus,
  ShoppingCart,
} from "lucide-react";
import { 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton
} from "@/components/ui/sidebar";

// Menu item type definition
interface MenuItem {
  title: string;
  icon: React.ElementType;
  path: string;
  resource: Resource;
  permissionType?: "read" | "write" | "delete";
}

// List of all menu items with their paths for getting page titles
export const menuItems: MenuItem[] = [
  { title: "Dashboard", icon: Home, path: "/dashboard", resource: "dashboard" },
  { title: "Voorraad", icon: Database, path: "/inventory", resource: "inventory" },
  { title: "Meldingen", icon: Bell, path: "/notifications", resource: "notifications" },
  { title: "Feedback", icon: MessageSquare, path: "/feedback", resource: "feedback" },
  { title: "Pakket Ophaaltijden", icon: Package, path: "/package-pickup", resource: "packagePickup" },
  { title: "Rapportages", icon: BarChart3, path: "/reports", resource: "reports" },
  { title: "Medewerkers", icon: Users, path: "/medewerkers", resource: "medewerkers" },
  { title: "Rollenbeheer", icon: ShieldCheck, path: "/rollenbeheer", resource: "rollenbeheer" },
  { title: "Gebruikersbeheer", icon: KeyRound, path: "/admin/gebruikers", resource: "gebruikersbeheer" },
  { title: "Registratie Aanvragen", icon: UserPlus, path: "/admin/registraties", resource: "registraties" },
  { title: "Nieuws+", icon: LayoutDashboard, path: "/modal-campagnes", resource: "nieuws" },
  { title: "Workflow Executions", icon: Workflow, path: "/workflow-executions", resource: "workflowExecutions" },
  { title: "Vervallen Producten", icon: AlertTriangle, path: "/expired-products", resource: "expiredProducts" },
  { title: "Nieuwe Producten", icon: PackagePlus, path: "/nieuwe-producten", resource: "nieuweProducten" },
  { title: "Orders", icon: ShoppingCart, path: "/orders", resource: "orders" },
  { title: "API Documentatie", icon: BookOpen, path: "/api-docs", resource: "apiDocs" },
];

const MenuItems = ({ role }: { role: UserRole }) => {
  const { hasPermission } = usePermissions();
  const isMobile = useIsMobile();
  
  // Filter items based on permissions from rollenbeheer
  const allowedItems = menuItems.filter(item => {
    const hasAccess = hasPermission(item.resource, item.permissionType || "read");
    return hasAccess;
  });

  return (
    <>
      {allowedItems.map((item) => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton asChild>
            <Link to={item.path} className="flex items-center">
              <item.icon className="w-5 h-5 mr-3" />
              <span>{item.title}</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </>
  );
};

export default MenuItems;

